// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/explicacaoDoPrecoDeConcorrencia.ts

/** A explicação do preço de concorrência vazio, quando existe uma — e nada quando não existe. */

export type LinhaComPrecoDeConcorrencia = {
  competitorsPrice?: number | null;
  clusterCompetitorPriceUnavailable?: boolean;
};

const SEM_DADO_DE_CLUSTER = 'Sem dado de concorrência para este cluster';

export const explicacaoDoPrecoDeConcorrencia = (linha: LinhaComPrecoDeConcorrencia): string | null => {
  const temPreco = linha.competitorsPrice !== null && linha.competitorsPrice !== undefined;

  // Havendo número, não há vazio a explicar. E o sinal ausente vale como "causa não medida": explicar sem
  // causa faria a tela errar onde hoje ela acerta em ficar calada.
  if (temPreco || !linha.clusterCompetitorPriceUnavailable) return null;

  return SEM_DADO_DE_CLUSTER;
};
